import PropTypes from 'prop-types'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'

import { Colors } from '~/styles'
import { Alerts, Loading } from '~/components'

import Styled from './generate-sr-modal.styled'
import useHooks from './generate-sr-modal.hooks'
import { FormContent, ModalConfirm } from './components'

const GenerateServiceRequestModal = (props) => {
  const { data, methods } = useHooks(props)

  return (
    <>
      <Styled.StyledDialog
        id='mdl_vessel_forecast_generate_sr_dialog'
        open={props.isOpen}
        width={40}
        onClose={methods.handleCloseForm}
        maxWidth='lg'
        fullWidth={true}
        aria-labelledby='mdl_vessel_forecast_generate_sr_dialog'
        disableEnforceFocus={true}
        disableBackdropClick={true}
      >
        <Styled.Header id='mdl_comp_dialog_header' whiteheader={props.whiteheader}>
          <Styled.TitleContainer>
            <Styled.DivTitle>
              <Styled.Title id='mdl_vessel_forecast_generate_sr_dialog_title'>Create New Request</Styled.Title>
            </Styled.DivTitle>
            <div id='modal-button' style={{ display: 'flex', alignItems: 'center' }}>
              <IconButton onClick={methods.handleCloseForm} aria-label='close' id='mdl_dialog_x_btn'>
                <CloseIcon htmlColor={Colors.pureWhite} />
              </IconButton>
            </div>
          </Styled.TitleContainer>
        </Styled.Header>

        {data.isLoading ? (
          <Styled.LoadingContainer>
            <Loading />
          </Styled.LoadingContainer>
        ) : (
          <FormContent data={data} methods={methods} />
        )}

        {data.openConfirmation && (
          <ModalConfirm
            open={data.openConfirmation}
            toggleModal={methods.toggleConfirmation}
            handleSubmit={methods.handleConfirmSubmit}
          />
        )}

        {data.showAlert.visible && (
          <Alerts
            id='mdl_vessel_forecast_generate_sr_dialog_alert'
            isOnFullscreenComponent
            msg={data.showAlert.msg}
            close={methods.handleCloseAlert}
            open={data.showAlert.visible}
            success={data.showAlert.success}
          />
        )}
      </Styled.StyledDialog>
    </>
  )
}

GenerateServiceRequestModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dataItem: PropTypes.object,
  whiteheader: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  toggleAlert: PropTypes.func.isRequired,
}

export default GenerateServiceRequestModal